/* eslint-disable max-len */
import { Component, OnDestroy, OnInit, HostBinding, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { BentoAlertItemOptions, BentoSideNavItem } from '@bento/bento-ng';
import { BaseService } from 'src/app/core/services/base/base.service';
import { environment } from 'src/environments/environment';
import { DownloadService } from 'src/app/core/services/download/download.service';
import { HttpParams } from '@angular/common/http';
import { FeatureToggleService } from 'src/app/core/services/feature-toggle/feature-toggle.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { TkHistoryRequest } from 'src/app/core/models/tk-history-request.model';
import { BackendTokenClaims } from 'src/app/core/models/tokenResponse';
declare let TRAAC: any;

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent implements OnInit, OnDestroy {
  // Add class to parent
  @ViewChild('globalResults') globalResults: ElementRef;
  @HostBinding('class.u-flexGrowCol') get ComponentClass(): boolean {
    return true;
  }
  //GLOBAL SEARCH
  globalSearchText: string = '';
  groupedGlobalResults: { [tab: string]: any[] } = {}
  globalSearchResults: { tab: string, file: any }[] = [];
  showGlobalResults: boolean = false;
  showAllGlobalResults: boolean = false;
  expandedGroups: { [tab: string]: boolean } = {};
  globalResultAnnouncement: string = '';

  errorMessage = '';
  isLoading = false;
  alerts: BentoAlertItemOptions[] = [];
  clientReportsArr = [];
  countryArr = [];
  selectedItemIndex: number | null = null;

  SIDE_NAV_SELECTOR =
    '.GlobalLayout-item.GlobalLayout-item--large a, .GlobalLayout-item.GlobalLayout-item--large button, .GlobalLayout-item.GlobalLayout-item--large input, .GlobalLayout-item.GlobalLayout-item--large select, .GlobalLayout-item.GlobalLayout-item--large [tabindex]';

  CLIENT_REPORTS_LABEL = 'Client reports';
  firstThreeDataByCountry: any[] = [];
  searchText: String = '';
  noResultsFound: boolean = false;
  resultAnnouncement = '';
  clientReportContentAddCount: number = 0; // Counter to track additions to client report content
  items: BentoSideNavItem[] = [
    {
      label: 'Reference documents',
      selected: true,
      data: { isVisible: true },
      id: 'reference-documents',
    },
    {
      label: 'User guide',
      data: { isVisible: false },
    },
    {
      label: 'Legal industry update',
      data: { isVisible: false },
    },
    {
      label: 'Client reports',
      collapsed: true,
      items: this.clientReportsArr,
      data: { isVisible: false },
      class: 'client-reports',
    },
    {
      label: 'Thought leadership reports',
      data: { isVisible: false },
    },
    {
      label: 'Law firm financial index',
      data: { isVisible: false },
    },
  ].map((item, index) => ({
    ...item,
    action: () => {
      this.showHideUserTabSideNav(item.label);
      this.setFocusToFirstLink(this.SIDE_NAV_SELECTOR, index);
      this.clearResources();
      if (item.label === this.CLIENT_REPORTS_LABEL) {
        // this.ensureSideNavExpanded(this.CLIENT_REPORTS_LABEL, () => this.focusSpecificLinks());
      }
    },
  }));

  private setFocusToFirstLink(selector: string, itemIndex: number = 0): void {
    setTimeout(() => {
      const links = Array.from(document.querySelectorAll(selector)) as HTMLElement[];

      if (links.length > 0) {
        links.forEach((link) =>
          link.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'ArrowLeft') {
              this.focusNextSideNavItem(itemIndex);
            }
          })
        );
        links[0].focus();
        const lastLink = links[links.length - 1];
        lastLink.addEventListener('keydown', (event: KeyboardEvent) => {
          if (event.key === 'Tab' && !event.shiftKey) {
            event.preventDefault();
            this.focusNextSideNavItem(itemIndex);
          }
        });
        lastLink.addEventListener('blur', () => {
          if (!document.activeElement || !document.querySelector(selector).contains(document.activeElement)) {
            this.focusNextSideNavItem(itemIndex);
          }
        });
        addEventListener('keydown', (event: KeyboardEvent) => {
          if (event.key === 'ArrowRight') {
            links[0].focus();
          }
        });
      } else {
        return;
      }
    }, 100);
  }

  private focusSpecificLinks(): void {
    const specificLinks = ['Australia', 'UK', 'US'];

    this.ensureSideNavExpanded(this.CLIENT_REPORTS_LABEL, () => {
      specificLinks.forEach((linkText) => {
        const links = Array.from(document.querySelectorAll(this.SIDE_NAV_SELECTOR)) as HTMLElement[];
        const link = links.find((l) => l.textContent?.trim() === linkText);
        if (link) link.focus();
        else console.warn(`Link with text "${linkText}" not found.`);
      });
    });
  }

  private ensureSideNavExpanded(parentLabel: string, callback: () => void): void {
    const parentNavItem = this.items.find((item) => item.label === parentLabel);

    if (parentNavItem && parentNavItem.data.isVisible) {
      callback();
    } else {
      this.showHideUserTabSideNav(parentLabel);

      // Wait for the DOM update to complete
      setTimeout(() => {
        callback();
      }, 100);
    }
  }

  private focusNextSideNavItem(currentIndex: number): void {
    let nextIndex = (currentIndex + 1) % this.items.length;
    let attempts = 0;
    const lastIndex = this.items.length - 1;
    while (!this.items[nextIndex].data.isVisible && attempts < this.items.length) {
      nextIndex = (nextIndex + 1) % this.items.length;
      attempts++;
    }
    if (currentIndex === lastIndex && this.items[lastIndex].label === 'Law firm financial index') {
      const externalElement = document.querySelector('.Header-logo') as HTMLElement;
      if (externalElement) {
        externalElement.focus();
      }
      return;
    }

    if (currentIndex === lastIndex && this.items[lastIndex].label === 'Law firm financial index') {
      // Move focus to .Header-logo when Tab is pressed
      if (event instanceof KeyboardEvent && event.key === 'Tab') {
        const externalElement = document.querySelector('.Header-logo') as HTMLElement;
        if (externalElement) {
          event.preventDefault();
          externalElement.focus();
        }
        return;
      }
    }

    if (this.selectedItemIndex !== null) {
      this.focusOnItem(this.selectedItemIndex);
      return;
    }

    if (attempts === this.items.length) {
      console.warn('No visible items found to focus on.');
      return;
    }

    this.focusOnItem(nextIndex);
  }

  private focusOnItem(index: number): void {
    const item = this.items[index];

    // Use more specific selector if needed
    const itemSelector = `.bento-side-nav-leaf.current-page a`;

    const element = document.querySelector(itemSelector) as HTMLAnchorElement;

    if (element) {
      element.focus();
    } else {
      console.warn(`Element for index ${index} not found.`);
    }
  }

  resourceContent;
  originalResourceContent;
  selectedCountry: string;
  isQuickSightEnabled = false;
  yearForPeerMonitor = [2019, 2020, 2021];
  constructor(
    private downloadFile: DownloadService,
    private service: BaseService,
    private featureToggleService: FeatureToggleService,
    private authService: AuthService,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnDestroy() {
    setTimeout(() => {
      var element = document.getElementById('resources');
      if (element) {
        element.classList.remove('router-link-active');
      }
    }, 0);
  }

  async ngOnInit(): Promise<void> {
    /***** TO BE REMOVED PART OF FEATURE TOGGLE - QUICKSIGHT ******/
    await this.featureToggleService.getFeatureValue('QUICKSIGHT').then((val) => (this.isQuickSightEnabled = val));
    /*************************************************************/
    if (this.isQuickSightEnabled) {
      TRAAC.track(TRAAC.keyValue('Resources click', { email: this.authService.getUserEmail() }).build());
    }
    this.isLoading = true; 
    this.service.get(environment.FIClientBaseEndpoint + 'v1/storage/listFiles', '').subscribe(
      (content) => {
        this.resourceContent = content;
        this.clientReports();
        this.originalResourceContent = JSON.parse(JSON.stringify(content));

        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = error.error;
        this.alerts.push({
          type: 'warning',
          msg: 'Something went wrong, please try again.',
          closeable: true,
        });
      }
    );

    setTimeout(() => {
      var element = document.getElementById('resources');
      if (element) {
        element.classList.add('router-link-active');
      }
    }, 0);
  }

  ngAfterViewChecked(): void {
    this.removeAriaExpandForAccessibility();
  }

  clientReports() {
    var itemObj;
    var items = [];
    this.resourceContent.clientReport.forEach((element) => {
      this.countryArr.push(element.country);
      itemObj = {
        label: element.country,
        selected: false,
        data: { isVisible: false },
        action: () => {
          this.clearResources();
          this.showHideUserTabSideNav(element.country);
          const indexToFocus = this.countryArr.indexOf(element.country);
          this.selectedItemIndex = indexToFocus + 1;
          this.setFocusToFirstLink(this.SIDE_NAV_SELECTOR, indexToFocus);
        },
      };

      items.push(itemObj);
      this.items.forEach((element) => {
        if (element.label === 'Client reports') {
          element.items = items;
        }
      });

      this.rebuildFirstThreeList(element);
    });
  }

  onImageLoad(imgLoadVal) {
    imgLoadVal.imageLoad = false;
  }

  showHideUserTabSideNav(label: string) {
    var isClient = false;
    this.items.forEach((element: BentoSideNavItem) => {
      if (element.label === label) {
        switch (element.label) {
          case 'Client reports':
            element.collapsed = false;
            element.data.isVisible = true;
            this.selectedCountry = element.items[0].label;
            isClient = true;
            element.items[0].data.isVisible = true;
            element.items[0].selected = true;
            //element.collapsed = false;
            element.items.forEach((item, index) => {
              if (item[index] > 0) {
                element.items[index].data.isVisible = false;
                element.items[index].selected = false;
              }
            });
            break;
          default:
            element.data.isVisible = true;
            break;
        }
      } else {
        element.data.isVisible = false;
      }

      this.countryArr.forEach((country, index) => {
        if (country == label) {
          this.selectedCountry = label;
          this.items[3].items[index].data.isVisible = true;
          this.items[3].items[index].selected = true;
        } else {
          if (!isClient) {
            this.items[3].items[index].selected = false;
            this.items[3].items[index].data.isVisible = false;
          }
        }
      });
    });

    document.addEventListener('keydown', (event: KeyboardEvent) => {
      const activeElement = document.activeElement as HTMLElement;
      if (event.key === 'Enter') {
        setTimeout(() => {
          const bentoSideNavLeaf = document.querySelectorAll('.bento-side-nav-leaf.current-page');
          const clientReportsItem = Array.from(document.querySelectorAll('.bento-side-nav-branch')).find(
            (item) => item.querySelector('.branch-root')?.textContent?.trim() === 'Client reports'
          );

          if (!clientReportsItem) return;
          const expandButton = clientReportsItem.querySelector('button[aria-expanded]');
          if (!expandButton) return;

          const isExpanded = expandButton.getAttribute('aria-expanded');
          if (activeElement.hasAttribute('aria-expanded')) {
            if (isExpanded === 'false') {
              (expandButton as HTMLElement).click();
              setTimeout(() => {
                document.querySelectorAll('[aria-current="page"]').forEach((el) => el.removeAttribute('aria-current'));
                const firstListItem = clientReportsItem.querySelector('ul li:first-child a');
                if (firstListItem) {
                  firstListItem.setAttribute('aria-current', 'page');
                }
              }, 100);
            }
          }
        }, 50);
      }
    });
  }

  private rebuildFirstThreeList(entry): void {
      const imageJson = this.resourceContent.resoucePageImages.reduce((acc, curr) => {
        const { locale, dataUrl, name } = curr;
        if (!acc[locale]) acc[locale] = [];
        acc[locale].push({ dataUrl, name });
        return acc;
      }, {} as { [key: string]: { dataUrl: string; name: string }[] });

      Object.keys(imageJson).forEach(locale => {
        imageJson[locale].sort((a, b) => a.name.localeCompare(b.name));
      });
    const allFiles = [];
    let count = 0,
      imageIndex = 0;
    const sortedYears = Object.keys(entry.files).sort((a, b) => parseInt(b) - parseInt(a));
    for (const year of sortedYears) {
      for (const file of entry.files[year]) {
        if (count >= 3) break;
        file.image = imageJson[entry.country][imageIndex % 3];
        file.imageLoad = true;
        allFiles.unshift(file);
        imageIndex++;
        count++;
      }
      if (count >= 3) break;
    }

    entry.firstThreeList = allFiles;
  }

  searchResources(): void {
    const query = (this.searchText || '').trim().toLowerCase();

    if (!this.originalResourceContent || query === '') {
      this.noResultsFound = false;
      this.clearResources();
      return;
    }

    let visibleTabIndex = this.items.findIndex((item) => item.data.isVisible); //giving -1 for us uk
    if (visibleTabIndex === -1 && this.items[3].items.some((i) => i.data.isVisible)) {
      visibleTabIndex = 3; //manually setting for c=ountries
    }

    switch (visibleTabIndex) {
      case 0: // Reference documents
        //Remove comment if search is needed for reference documents and add search in HTML
        // this.resourceContent.reference = this.originalResourceContent.reference.filter(file =>
        //   file.name.toLowerCase().includes(query)
        // );
        break;

      case 1:
        // User guide
        //same as above
        break;

      case 2: // Legal industry update
        this.noResultsFound = false;

        this.resourceContent.liu = this.originalResourceContent.liu
          .map((entry) => {
            const filteredFiles = {};
            let matchFound = false;
            Object.entries(entry.files).forEach(([key, files]: any) => {
              const matched = files.filter((file) => {
                const searchWords = query.split(/\s+/).filter((word) => word.length > 0);
                const searchString = `${file.name} ${entry.year} ${key}`.toLowerCase(); //PDF names + h3 year + h3 country
                const isMatch = searchWords.every((word) => searchString.includes(word));
                return isMatch;
              });

              if (matched.length > 0) {
                filteredFiles[key] = matched;
                matchFound = true;
              }
            });
            return matchFound ? { ...entry, files: filteredFiles } : null;
          })
          .filter((entry) => entry !== null);
        this.noResultsFound = this.resourceContent.liu.length === 0;
        this.resultAnnouncement = `${this.resourceContent.liu.length} result${this.resourceContent.liu.length > 1 ? 's' : ''
          } found`;
        break;

      case 3: // Client reports
        const visibleCountries = this.items[3].items.filter((i) => i.data.isVisible).map((i) => i.label);

        if (!this.originalResourceContent || query.length <= 1) {
          this.resourceContent.clientReport = JSON.parse(
            JSON.stringify(this.originalResourceContent.clientReport)
          ).filter((entry) => visibleCountries.includes(entry.country));
          this.resourceContent.clientReport.forEach((entry) => this.rebuildFirstThreeList(entry));
          this.noResultsFound = false;
          return;
        }

        this.resourceContent.clientReport = this.originalResourceContent.clientReport
          .map((entry) => {
            if (!visibleCountries.includes(entry.country)) return null;
            const filteredFiles = {};
            let matchFound = false;
            for (const [year, files] of Object.entries(entry.files)) {
              const matches = (files as any[]).filter((file) => {
                const searchWords = query.split(/\s+/).filter((word) => word.length > 0);
                const searchString = `${file.name} ${entry.country} ${year}`.toLowerCase();
                return searchWords.every((word) => searchString.includes(word));
              });
              if (matches.length) {
                filteredFiles[year] = matches;
                matchFound = true;
              }
            }
            return matchFound ? { ...entry, files: filteredFiles, firstThreeList: [] } : null;
          })
          .filter((entry) => entry !== null);

        this.noResultsFound = this.resourceContent.clientReport.length === 0;
        this.resultAnnouncement = `${this.resourceContent.clientReport.length} result${this.resourceContent.clientReport.length > 1 ? 's' : ''
          } found`;
        break;

      case 4: // Thought leadership
        this.noResultsFound = false;
        this.resourceContent.thoughtLeadershipReports = this.originalResourceContent.thoughtLeadershipReports
          .map((entry) => {
            const filteredFiles = {};
            let matchFound = false;
            Object.entries(entry.files).forEach(([key, files]: any) => {
              const matched = files.filter((file) => {
                const searchWords = query.split(/\s+/).filter((word) => word.length > 0);
                const searchString = `${file.name} ${entry.year} ${key}`.toLowerCase(); //PDF names + h3 year + h3 country
                const isMatch = searchWords.every((word) => searchString.includes(word));
                return isMatch;
              });
              if (matched.length > 0) {
                filteredFiles[key] = matched;
                matchFound = true;
              }
            });
            return matchFound ? { ...entry, files: filteredFiles } : null;
          })
          .filter((entry) => entry !== null);
        this.noResultsFound = this.resourceContent.thoughtLeadershipReports.length === 0;
        this.resultAnnouncement = `${this.resourceContent.thoughtLeadershipReports.length} result${this.resourceContent.thoughtLeadershipReports.length > 1 ? 's' : ''
          } found`;
        break;

      case 5: // Law firm financial index Pending
        this.noResultsFound = false;
        this.resourceContent.lawFirmFinancialIndex = this.originalResourceContent.lawFirmFinancialIndex
          .map((entry) => {
            const filteredFiles = {};
            let matchFound = false;
            Object.entries(entry.files).forEach(([key, files]: any) => {
              const matched = files.filter((file) => {
                const searchWords = query.split(/\s+/).filter((word) => word.length > 0);
                const searchString = `${file.name} ${entry.year} ${key}`.toLowerCase(); //PDF names + h3 year + h3 country
                const isMatch = searchWords.every((word) => searchString.includes(word));
                return isMatch;
              });
              if (matched.length > 0) {
                filteredFiles[key] = matched;
                matchFound = true;
              }
            });
            return matchFound ? { ...entry, files: filteredFiles } : null;
          })
          .filter((entry) => entry !== null);
        this.noResultsFound = this.resourceContent.lawFirmFinancialIndex.length === 0;
        this.resultAnnouncement = `${this.resourceContent.lawFirmFinancialIndex.length} result${this.resourceContent.lawFirmFinancialIndex.length > 1 ? 's' : ''
          } found`;
        break;
    }
  }

  clearResources(): void {
    //when user clicks on any tab, clear the search text and reset the resource content
    this.searchText = '';
    this.noResultsFound = false;
    this.resourceContent = JSON.parse(JSON.stringify(this.originalResourceContent));
    const isClientReportsTabActive = this.items[3].data.isVisible;
    if (this.resourceContent.clientReport && isClientReportsTabActive) {
      const countries = this.resourceContent.clientReport.map((entry) => entry.country);
      this.items[3].items.forEach((i) => {
        i.data.isVisible = countries.includes(i.label);
      });
      this.resourceContent.clientReport.forEach((entry) => this.rebuildFirstThreeList(entry));
    }
  }

  searchAllResources(): void {
    //close search if user clears the search text using bentoReset
    const gquery = (this.globalSearchText || '').trim().toLowerCase();

    if (gquery === '') {
       this.closeGlobalSearch();
      return;
    }
    this.globalSearchText = this.globalSearchText.trim();
    this.expandedGroups = {};
    const query = this.globalSearchText.trim().toLowerCase();
    if (!query || !this.originalResourceContent) {
      this.globalSearchResults = [];
      this.showGlobalResults = false;
      return;
    }

    const searchInFiles = (entries: any[], tab: string): any[] => {
      const matches = [];

      entries.forEach(entry => {
        // CASE 1: Grouped entries (e.g., liu, clientReport, etc.)
        if (entry.files) {
          for (const [year, files] of Object.entries(entry.files)) {
            (files as any[]).forEach(f => {
              const searchText = `${f.name} ${entry.year ?? ''} ${entry.country ?? ''} ${year ?? ''}`.toLowerCase();
              const words = query.split(/\s+/).filter(Boolean);
              if (words.every(w => searchText.includes(w))) {
                const sublabel = tab === 'Client reports' && entry.country ? `Client reports > ${entry.country}` : tab;
                matches.push({ tab: sublabel, file: f });
              }
            });
          }
        }

        // CASE 2: Flat file entries (e.g., reference, userGuide)
        else if (entry.name) {
          const searchText = entry.name.toLowerCase();
          const words = query.split(/\s+/).filter(Boolean);
          if (words.every(w => searchText.includes(w))) {
            matches.push({ tab, file: entry });
          }
        }
      });

      return matches;
    };

    const results = [
      ...(this.originalResourceContent.reference ? searchInFiles(this.originalResourceContent.reference, 'Reference documents') : []),
      ...(this.originalResourceContent.userGuide ? searchInFiles(this.originalResourceContent.userGuide, 'User guide') : []),
      ...(this.originalResourceContent.liu ? searchInFiles(this.originalResourceContent.liu, 'Legal industry update') : []),
      ...(this.originalResourceContent.clientReport ? searchInFiles(this.originalResourceContent.clientReport, 'Client reports') : []),
      ...(this.originalResourceContent.thoughtLeadershipReports ? searchInFiles(this.originalResourceContent.thoughtLeadershipReports, 'Thought leadership reports') : []),
      ...(this.originalResourceContent.lawFirmFinancialIndex ? searchInFiles(this.originalResourceContent.lawFirmFinancialIndex, 'Law firm financial index') : []),
    ];

    this.globalSearchResults = results;
    this.groupedGlobalResults = results.reduce((acc, result) => {
      if (!acc[result.tab]) acc[result.tab] = [];
      acc[result.tab].push(result.file);
      return acc;
    }, {});
    this.showGlobalResults = true;
    this.globalResultAnnouncement = `${results.length} result${results.length !== 1 ? 's' : ''} found`;
  }

  hasMoreThanThreeResults(): boolean {
    return Object.values(this.groupedGlobalResults).some(files => files.length > 3);
  }

  closeGlobalSearch(){
    this.globalSearchText = '';
    this.showGlobalResults = false;
    this.globalSearchResults = [];
    this.groupedGlobalResults = {};
    this.expandedGroups = {};
    this.globalResultAnnouncement = '';
  }


  downloadResourceFile(blobName: string, fileName: string, extension: string) {
    if (this.isQuickSightEnabled) {
      this.onTrackDownloadResourceFile(blobName, fileName);
    }
    let params = new HttpParams();
    params = params.set('blobName', blobName);
    params = params.set('fileName', fileName);
    this.service.downloadExcel(environment.FIClientBaseEndpoint + 'v1/storage/downloadFile?' + params).subscribe(
      (response) => {
        this.downloadFile.downloadWithExtension(
          response.body,
          response.headers.get('content-disposition').split('=')[1],
          extension
        );
      },
      (error) => {
        this.errorMessage = error.error;
        this.alerts.push({
          type: 'warning',
          msg: 'Something went wrong, please try again.',
          closeable: true,
        });
      }
    );
  }

  asIsOrder(a, b) {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  }

  removeAriaExpandForAccessibility() {
    const liElements = this.el.nativeElement.querySelectorAll('li.bento-side-nav-branch.ng-star-inserted');
    liElements.forEach((li) => {
      this.renderer.removeAttribute(li, 'aria-expanded');
    });
  }
  onTrackDownloadResourceFile(blobName: String, fileName: string) {
    if (this.isQuickSightEnabled) {
      const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
      TRAAC.track(
        TRAAC.keyValue('Resources document download click', {
          firmId: backendTokenClaims.userDDO.firmID,
          userId: backendTokenClaims.userDDO.userID,
          DocumentName: fileName,
          documentCategory: blobName.split('/')[0],
        }).build()
      );
    }
  }
}
